import { createPlanNameMatcher } from './utils/PlanMetaHelper';
import { IPlanContent } from '../typings';
import { defaultEstimatesDialog, ongoingKeyDetails } from './common/planDefaults';

export const originBusinessDayShiftContent: IPlanContent = {
  test: createPlanNameMatcher(['Origin Business Day Shift']),
  content: {
    rateDiscountText: {
      defaultState: {
        defaultFuel: 'Rates variable on an ongoing plan',
      },
    },
    keyDetails: {
      defaultState: {
        defaultFuel: ongoingKeyDetails,
      },
    },
    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
        electricity: [],
      },
    },
    uiOptions: {
      defaultState: {
        defaultFuel: {
          planColor: {
            text: {
              styleGuide: 'blue',
              odsCore: 'promote',
            },
            promobox: {
              styleGuide: 'blue',
              odsCore: 'promote',
            },
            bannerText: {
              styleGuide: 'white',
              odsCore: 'white',
            },
          },
          imageForFuelType: {
            electricity:
              'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-weekday-shift.svg',
            gas: 'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-weekday-shift.svg',
            dual: 'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-weekday-shift.svg',
          },
        },
      },
    },
    tagLine: {
      defaultState: {
        defaultFuel: 'Variable rates on an ongoing plan',
      },
    },
    termsAndConditionsUrl: {
      defaultState: {
        defaultFuel: '/terms-and-conditions/origin-business-day-shift',
      },
    },
    estimatesDialog: defaultEstimatesDialog({ customerType: 'business' }),
  },
};
